import { createContext, useContext, useEffect, useState } from 'react';
import { isMobileOnly } from 'react-device-detect';

export const MOBILE_BREAKPOINT = 767;

const ViewportWidthContext = createContext(window.innerWidth);

export const MobileProvider = ({ children }) => {
    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <ViewportWidthContext.Provider value={width}>
            {children}
        </ViewportWidthContext.Provider>
    );
};

export const useIsMobile = (breakpoint = MOBILE_BREAKPOINT) => {
    const width = useContext(ViewportWidthContext);
    return isMobileOnly || width <= breakpoint;
};
